import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  /* Força o tema claro mesmo em dispositivos com dark mode ativado */
  :root {
    color-scheme: light;
  }

  /* CSS Reset - Limpa os estilos padrões do navegador */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
  }

  html {
    font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    font-size: 100%;
  }

  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.mediumGray};
    line-height: 1.5;
    overflow-x: hidden;
    padding: 0;
    margin: 0;
  }

  strong {
    font-weight: bold;
  }

  .content {
    max-width: 1640px;
    margin: 0 auto;
    padding: 0 16px;
  }
`;
